//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionBuilder.js";
import "../no/SelectCurveList.js";
import "../Motion/Motion.SelectLink.js";
import "../no/Expression.js";
import "../no/PointList.js";
import "../Motion/Motion.SelectBaseSection.js";
import "../Motion/Motion.SelectSplineBeamProperty.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"BeamType",1,0],[1,"Curves",0,"SelectCurveList",0],[0,"DefinitionMethod",1,0],[1,"Link",0,"Motion.SelectLink",0],[0,"ListMarkerOvrCtrl",1,0],[0,"Name",1,0],[0,"NumberOfBeamSections",0,0],[1,"NumberOfSections",0,"Expression",0],[1,"PointList",0,"PointList",0],[0,"SectionAxis",1,0],[1,"SectionShape",0,"Motion.SelectBaseSection",1],[0,"SectionVector",1,"Direction",0],[1,"StructuralProperty",0,"Motion.SelectSplineBeamProperty",0],[1,"Tolerance",0,"Expression",0],[0,"ToleranceOvrCtrl",1,0],[0,"UseMarkersAsPassingPoints",1,0]],[[["index"],"InsertEmptyPoint",{},1,0],[["index","point"],"AssignPoint",{},2,0],[["index"],"RemovePoint",{},1,0],[["index1","index2"],"SwapPoints",{},2,0],[[],"GeneratePoints",{},0,0],[["filePath"],"ImportPointsFromFile",{},1,0],[["filePath"],"ExportPointsToFile",{},1,0],[["numListItem"],"GetMarkerItems",{R_:{markerToNodeListItem:"Motion.MarkerToNodeData[]"}},0,0],[["markerName"],"FindMarkerItem",{R_:{markerToNodeItem:"Motion.MarkerToNodeData"}},1,0],[[],"RemoveAllMarkers",{},0,0],[["marker","markerPosition","pointID","useClosestNode"],"CreateMarkerToNode",{R_:{markerToNode:"Motion.MarkerToNodeData"}},4,0],[[],"RecalculateMarkersPositions",{},0,0],[[],"AppendBeamSection",{},0,0],[["sectionIndex"],"RemoveBeamSection",{},1,0],[["sectionIndex","endPoint"],"SetBeamSectionEndPoint",{},2,0],[["sectionIndex"],"GetBeamSectionEndPoint",{R_:{endPoint:''}},1,0],[["sectionIndex","tagSection"],"SetBeamSectionSection",{},2,0],[["sectionIndex"],"GetBeamSectionSection",{R_:{tagSection:"Motion.BaseSection"}},1,0]],[]];
SPLM.Motion.SplineBeamBuilder = class extends SPLM.Motion.MotionBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.SplineBeamBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.SplineBeamBuilder.BeamTypeValue = Object.freeze({
    "LumpedMass" : "LumpedMass", "NonlinearFlexible" : "NonlinearFlexible"});

SPLM.Motion.SplineBeamBuilder.DefinitionMethodType = Object.freeze({
    "Manual" : "Manual", "Curve" : "Curve"});

SPLM.Motion.SplineBeamBuilder.SectionAxisType = Object.freeze({
    "Y" : "Y", "Z" : "Z"});

export default SPLM;